<template>
  <div class="reset-page col-block" :style="{ minHeight: minHeight }">
    <div class="content-container col-block" :style="{ flex: 1 }">
      <div class="reset-container col-block default-shadow">
        <div class="title-container sub-title center-block">
          <span>重設密碼</span>
        </div>
        <div class="content-block" :style="{ width: '100%' }">
          <div>請以6碼以上字元設定新密碼。</div>
        </div>
        <div class="main-container">
          <div class="row">
            <div class="input-group no-padding col">新密碼<span class="alert">*</span></div>
          </div>
          <div class="row">
            <div class="input-group col">
              <input type="password" id="password" name="password" v-model="reset.password" v-validate="'required|min:6|max:250'">
              <p class="error" v-show="errors.has('password')">{{ '密碼不符規定，請設6碼以上英數字之密碼' }}</p>
            </div>
          </div>
          <div class="row" :style="{ height: '10px' }"></div>
          <div class="row">
            <div class="input-group no-padding col">確認密碼<span class="alert">*</span></div>
          </div>
          <div class="row">
            <div class="input-group col">
              <input type="password" id="confirmed" name="confirmed" v-model="reset.confirmed" v-validate="'required'">
              <p class="error" v-show="errors.has('confirmed')">{{ (errors.first('confirmed') || '').replace('confirmed', '確認密碼') }}</p>
            </div>
          </div>
        </div>
        <div :style="{ flex: 1 }"></div>
        <div class="options-container col-block">
          <button type="button" name="button" class="main-button" :class="{ loading: onSubmit }" :disabled="onError" @click="e => validatePasswordReset()">
            <span>送出</span>
          </button>
        </div>
      </div>
      <div :style="{ flex: 1 }"></div>
    </div>
    <div class="footer-container">
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { postResetUserPassword } from '../../api'
import loginMethods from '../../mixins/loginData'
import toastMethods from '../../mixins/toastMethods'

export default {
  mixins: [
    loginMethods,
    toastMethods
  ],
  props: {
    minHeight: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      reset: {
        password: '',
        confirmed: '',
        usr_id: '',
        reset_password_token: ''
      },
      onSubmit: false
    }
  },
  computed: {
    onError () {
      let value = true
      if (this.errors.items.length === 0) {
        value = false
      }
      if (this.loading) {
        value = true
      }
      return value
    }
  },
  created () {
    if (this.$route.query.user_id && this.$route.query.reset_password_token) {
      this.reset.reset_password_token = this.$route.query.reset_password_token
      this.reset.user_id = this.$route.query.user_id
    } else {
      this.$router.push({ name: 'main' })
    }
  },
  methods: {
    ...mapActions([
      'setModalAction'
    ]),
    async validatePasswordReset () {
      this.onSubmit = true
      let result = await this.$validator.validateAll()
      if (result) {
        if (this.reset.password === this.reset.confirmed) {
          await this.passwordReset()
        } else {
          this.addToast('error', '兩次密碼輸入不相同')
          this.onSubmit = false
        }
      } else {
        this.onSubmit = false
      }
    },
    async passwordReset () {
      try {
        let data = this.reset
        await postResetUserPassword(data)
        this.addToast('success', '重設成功')
        this.$router.push({ name: 'main' })
        this.onSubmit = false
      } catch (error) {
        this.setLoginAction(false)
        this.addToast('error', !error.response ? error.message : error.response.data.message || error.response.data.errors.join('<br>'))
        this.onSubmit = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/main/reset.vue